export default __webpack_public_path__ + "cf5253667f6b59b893c18fc6a0f9f3a2.png";